// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBszMXbFBDsTXv7AL9ZoraW_xxqmAuPwso",
  authDomain: "pass-buff.firebaseapp.com",
  projectId: "pass-buff",
  storageBucket: "pass-buff.appspot.com",
  messagingSenderId: "847035890323",
  appId: "1:847035890323:web:0223cabdd50b1d8d4eab66",
  measurementId: "G-NHTWNK5VB6"
};

// Initialize Firebase
const fireApp = initializeApp(firebaseConfig);

export default fireApp